import { useQuery } from "@tanstack/react-query"
import { getSignageAdvertisementMedia } from "@httpServices/signage"

export const SIGNAGE_ADVERTISEMENT_QUERY_KEY = ["signage", "advertisement"]
const useAdvertisementData = () => {
  return useQuery({
    queryKey: SIGNAGE_ADVERTISEMENT_QUERY_KEY,
    queryFn: async () => {
      try {
        return (await getSignageAdvertisementMedia()).data || []
      } catch (error) {}

      return []
    },
  })
}

export default useAdvertisementData
